import React, { useState, useEffect, useReducer, useRef, useContext } from "react";

import { isSameDay, parseISO, format } from "date-fns";
import openSocket from "socket.io-client";
import clsx from "clsx";

import { green } from "@material-ui/core/colors";
import { toast } from "react-toastify";
import {
  Button,
  CircularProgress,
  Divider,
  IconButton,
  Popover,
  Tooltip,
  makeStyles,
} from "@material-ui/core";
import {
  Cancel,
  AccessTime,
  Block,
  Done,
  DoneAll,
  ExpandMore,
  GetApp,
  PhoneAndroid,
  FlashOn,
  Mood,
  Add,
  LocalOffer,
  OpenInNew,
  PlayCircleFilled,
  Reply,
} from "@material-ui/icons";
import "emoji-mart/css/emoji-mart.css";
import { Picker } from "emoji-mart";

import MarkdownWrapper from "../MarkdownWrapper";
import VcardPreview from "../VcardPreview";
import VcardGrupoPreview from "../VcardPreview/VcardGrupoPreview";
import { lerVCards, resumoDoVCard } from "../../helpers/vcard";
import LocationPreview from "../LocationPreview";
import ModalImageCors from "../ModalImageCors";
import MessageOptionsMenu from "../MessageOptionsMenu";
import AudioMessage from "../AudioMessage";

import api, { createApi } from "../../services/api";
import toastError from "../../errors/toastError";
import { AuthContext } from "../../context/Auth/AuthContext";
import { i18n } from "../../translate/i18n";
import { nomeArquivoSalvo } from "../../helpers/legendaMidia";
import { nomeOriginalDocumento, nomeDownloadMidia, nomeArquivoNoCard, legendaAbaixoDoCard } from "../../helpers/nomeDownloadMidia";
import { ehEncaminhada } from "../../helpers/mensagemEncaminhada";
import { aoReconectar } from "../../helpers/reconexaoSocket";
import { motivoFalhaEnvio } from "../../helpers/motivoFalhaEnvio";
import { fundoConversa } from "../../helpers/fundoConversa";

//import { CSVLink } from 'react-csv';
//import Grid from "@material-ui/core/Grid";
//import Box from "@material-ui/core/Box";

//const http = require('http');

/*const init = {
  host: 'localhost',
  path: '/zdgSyncMessageUser',
  port: 8080,
  method: 'POST',
  headers: {
    'content-type': 'application/json; charset=utf-8'
  }
};

const init2 = {
  host: 'localhost',
  path: '/zdgGetWppId',
  port: 8080,
  method: 'POST',
  headers: {
    'content-type': 'application/json; charset=utf-8'
  }
};

const init3 = {
  host: 'localhost',
  path: '/zdgSendEmailAttach',
  port: 8080,
  method: 'POST',
  headers: {
    'content-type': 'application/json; charset=utf-8'
  }
};

const callback = function (response) {
  let result = Buffer.alloc(0);
  response.on('data', function (chunk) {
    result = Buffer.concat([result, chunk]);
  });

  response.on('end', function () {
    console.log(result.toString());
  });
};

const callback2 = function (response) {
  let result = Buffer.alloc(0);
  response.on('data', function (chunk) {
    result = Buffer.concat([result, chunk]);
  });

  response.on('end', function () {
    alert("ID WPP Ativo para esse Ticket: " + result.toString().replace(/[^0-9.]/g, ""));
  });
};*/

const useStyles = makeStyles((theme) => ({
  messagesListWrapper: {
    overflow: "hidden",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
  },

  messagesList: {
    backgroundImage: ({ canal }) => fundoConversa(canal, theme),
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    padding: "20px 20px 20px 20px",
    overflowY: "scroll",
    ...theme.scrollbarStyles,
  },

  circleLoading: {
    color: green[500],
    position: "absolute",
    opacity: "70%",
    top: 0,
    left: "50%",
    marginTop: 12,
  },

  messageLeft: {
    // o vão até o botão de reagir, que agora vive nesse espaço (era 20)
    marginRight: 6,
    marginTop: 2,
    minWidth: 100,
    maxWidth: 600,
    height: "auto",
    display: "block",
    position: "relative",
    "&:hover #messageActionsButton": {
      display: "flex",
      position: "absolute",
      top: 0,
      right: 0,
    },

    whiteSpace: "pre-wrap",
    backgroundColor: "var(--bubble-in)",
    color: "var(--text-primary)",
    alignSelf: "flex-start",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    paddingLeft: 5,
    paddingRight: 5,
    paddingTop: 5,
    paddingBottom: 0,
    boxShadow: "var(--shadow)",
  },

  quotedContainerLeft: {
    margin: "-3px -80px 6px -6px",
    overflow: "hidden",
    backgroundColor: "var(--surface-2)",
    borderRadius: "7.5px",
    display: "flex",
    position: "relative",
  },

  quotedMsg: {
    padding: 10,
    maxWidth: 300,
    height: "auto",
    display: "block",
    whiteSpace: "pre-wrap",
    overflow: "hidden",
  },

  quotedSideColorLeft: {
    flex: "none",
    width: "4px",
    backgroundColor: "#6bcbef",
  },

  // Card do anúncio de origem (Click-to-WhatsApp). Mesma linguagem visual da mensagem
  // citada — inclusive o -80px, que come o vão que o textContentItem reserva pra hora.
  anuncioCard: {
    margin: "-3px -80px 6px -6px",
    display: "flex",
    alignItems: "stretch",
    overflow: "hidden",
    backgroundColor: "var(--surface-2)",
    borderRadius: "7.5px",
    textDecoration: "none",
    color: "inherit",
    "&:hover": {
      filter: "brightness(0.97)",
    },
  },

  anuncioBarra: {
    flex: "none",
    width: "4px",
    backgroundColor: "#00a884",
  },

  anuncioMiniaturaBox: {
    flex: "none",
    position: "relative",
    width: 66,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "var(--surface-3, rgba(0,0,0,0.06))",
  },

  anuncioMiniatura: {
    width: "100%",
    height: "100%",
    maxHeight: 92,
    objectFit: "cover",
    display: "block",
  },

  anuncioPlay: {
    position: "absolute",
    color: "#fff",
    fontSize: 26,
    filter: "drop-shadow(0 0 3px rgba(0,0,0,0.6))",
    pointerEvents: "none",
  },

  anuncioTextos: {
    padding: "6px 10px",
    minWidth: 0,
    maxWidth: 300,
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },

  anuncioFonte: {
    display: "flex",
    alignItems: "center",
    gap: 4,
    fontSize: 11,
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: 0.3,
    color: "#00a884",
  },

  anuncioFonteIcone: {
    fontSize: 13,
  },

  anuncioTitulo: {
    fontSize: 13,
    fontWeight: 600,
    color: "var(--text-primary)",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },

  // O texto do anúncio costuma ser um panfleto inteiro: 3 linhas e o resto no title.
  anuncioCorpo: {
    fontSize: 12,
    lineHeight: 1.35,
    color: "var(--text-muted)",
    display: "-webkit-box",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    whiteSpace: "pre-wrap",
  },

  anuncioLink: {
    display: "flex",
    alignItems: "center",
    gap: 3,
    fontSize: 11,
    color: "var(--text-muted)",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },

  anuncioLinkIcone: {
    fontSize: 12,
  },

  messageRight: {
    // o vão até o botão de reagir, que agora vive nesse espaço (era 20)
    marginLeft: 6,
    marginTop: 2,
    minWidth: 100,
    maxWidth: 600,
    height: "auto",
    display: "block",
    position: "relative",
    "&:hover #messageActionsButton": {
      display: "flex",
      position: "absolute",
      top: 0,
      right: 0,
    },

    whiteSpace: "pre-wrap",
    backgroundColor: "var(--bubble-out)",
    color: "var(--text-primary)",
    alignSelf: "flex-end",
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 0,
    paddingLeft: 5,
    paddingRight: 5,
    paddingTop: 5,
    paddingBottom: 0,
    boxShadow: "var(--shadow)",
  },

  quotedContainerRight: {
    margin: "-3px -80px 6px -6px",
    overflowY: "hidden",
    backgroundColor: "var(--surface-3)",
    borderRadius: "7.5px",
    display: "flex",
    position: "relative",
  },

  quotedMsgRight: {
    padding: 10,
    maxWidth: 300,
    height: "auto",
    whiteSpace: "pre-wrap",
  },

  quotedSideColorRight: {
    flex: "none",
    width: "4px",
    backgroundColor: "#35cd96",
  },

  messageActionsButton: {
    display: "none",
    position: "relative",
    color: "#999",
    zIndex: 1,
    backgroundColor: "inherit",
    opacity: "90%",
    "&:hover, &.Mui-focusVisible": { backgroundColor: "inherit" },
  },

  messageContactName: {
    display: "flex",
    color: "#6bcbef",
    fontWeight: 500,
  },

  // Marca "Encaminhada", no mesmo lugar em que o WhatsApp mostra: acima do conteúdo,
  // em cinza e itálico. O ícone é a seta de responder espelhada — é o glifo que o
  // WhatsApp usa para encaminhamento.
  encaminhada: {
    display: "flex",
    alignItems: "center",
    gap: 3,
    padding: "3px 6px 0 6px",
    color: theme.palette.text.secondary,
    fontStyle: "italic",
    fontSize: 12,
    opacity: 0.8,
  },

  encaminhadaIcone: {
    fontSize: 14,
    transform: "scaleX(-1)",
  },

  // Tarja "Mensagem apagada pelo cliente" (#15256). Mesmo tratamento da Encaminhada —
  // acima da mídia e do corpo —, mas em vermelho discreto: aqui o aviso é que o
  // conteúdo abaixo NÃO vale mais, e não pode se perder no meio do balão.
  apagada: {
    display: "flex",
    alignItems: "center",
    gap: 3,
    padding: "3px 6px 0 6px",
    color: theme.palette.error.main,
    fontStyle: "italic",
    fontSize: 12,
  },

  apagadaIcone: {
    fontSize: 14,
  },

  textContentItem: {
    overflowWrap: "break-word",
    padding: "3px 100px 6px 6px",
  },

  textContentItemDeleted: {
    fontStyle: "italic",
    color: "var(--text-muted)",
    overflowWrap: "break-word",
    padding: "3px 100px 6px 6px",
  },

  // Mídia sem legenda: sem texto o textContentItem fica com ~9px de altura e a
  // linha de infos (hora, ack, ícone de outro aparelho — position absolute,
  // bottom 0) invadia a mídia. Os 26px reservam a mesma folga que o balão tem
  // quando existe legenda; vem junto com textContentItem (padding vem de lá).
  textContentItemSemLegenda: {
    minHeight: 26,
  },

  // Balãozinho de reação, como no WhatsApp Web: pendurado na borda de baixo do balão.
  // Fica à esquerda nos dois lados porque a direita é da hora/checks (position
  // absolute, bottom 0). Quem tem reação ganha folga embaixo (messageWithReactions)
  // para o balãozinho não invadir a mensagem seguinte.
  reactionsBubble: {
    position: "absolute",
    bottom: -11,
    left: 6,
    display: "inline-flex",
    alignItems: "center",
    gap: 3,
    padding: "1px 6px",
    borderRadius: 12,
    fontSize: 13,
    lineHeight: "18px",
    cursor: "default",
    backgroundColor: "var(--surface-2)",
    border: "1px solid var(--border)",
    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.25)",
    zIndex: 1,
  },

  reactionsCount: {
    fontSize: 11,
    color: "var(--text-secondary)",
  },

  messageWithReactions: {
    marginBottom: 14,
  },

  // Linha da mensagem: o balão de um lado e o botão de reagir FORA dele, do lado que
  // sobra (igual WhatsApp Web). O hover é na linha inteira — mirar no balão para achar
  // o botão é ruim de usar.
  // Pisca a linha da mensagem achada na busca (ver irParaMensagem).
  destaqueBusca: {
    animation: "$piscarBusca 2.5s ease-out",
  },
  "@keyframes piscarBusca": {
    "0%, 60%": { backgroundColor: "rgba(255, 213, 0, 0.35)" },
    "100%": { backgroundColor: "transparent" },
  },

  linhaMensagem: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    "&:hover #messageReactButton": {
      visibility: "visible",
    },
  },

  // Minha mensagem fica à direita: row-reverse mantém o balão na borda e joga o botão
  // para a esquerda dele, sem precisar reordenar o JSX.
  linhaMensagemMinha: {
    flexDirection: "row-reverse",
  },

  reactButton: {
    // visibility, e NÃO display: o anchorEl do Popover precisa manter caixa de layout.
    // Com display:none o getBoundingClientRect zera e o seletor pisca e pula para o
    // canto superior esquerdo da tela.
    visibility: "hidden",
    flex: "none",
    margin: 0,
    padding: 6,
    color: "var(--text-muted)",
  },

  // Enquanto o seletor daquela mensagem está aberto o botão continua visível, mesmo
  // com o mouse já dentro do popover (que é portal, fora da linha).
  reactButtonVisivel: {
    visibility: "visible",
  },

  reactIcon: {
    fontSize: 18,
  },

  // Barrinha rápida (as 6 reações que o WhatsApp oferece) + atalho para o seletor
  // completo. Some ao clicar fora (ClickAwayListener no Popover).
  reactBarra: {
    display: "flex",
    alignItems: "center",
    gap: 2,
    padding: "4px 6px",
    borderRadius: 20,
    backgroundColor: "var(--surface-1)",
  },

  reactBarraItem: {
    fontSize: 22,
    lineHeight: "26px",
    padding: "2px 4px",
    borderRadius: "50%",
    cursor: "pointer",
    background: "none",
    border: "none",
    "&:hover": { transform: "scale(1.25)" },
  },

  reactBarraItemAtivo: {
    backgroundColor: "var(--surface-3)",
  },

  reactBarraMais: {
    fontSize: 16,
    color: "var(--text-secondary)",
  },

  messageMedia: {
    objectFit: "cover",
    width: 250,
    height: 200,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
  },

  timestamp: {
    fontSize: 11,
    position: "absolute",
    bottom: 0,
    right: 5,
    color: "var(--text-muted)",
  },

  dailyTimestamp: {
    alignItems: "center",
    textAlign: "center",
    alignSelf: "center",
    width: "110px",
    backgroundColor: "var(--surface-2)",
    margin: "10px",
    borderRadius: "10px",
    boxShadow: "0 1px 1px #b3b3b3",
  },

  dailyTimestampText: {
    color: "var(--text-secondary)",
    padding: 8,
    alignSelf: "center",
    marginLeft: "0px",
  },

  ackIcons: {
    fontSize: 18,
    verticalAlign: "middle",
    marginLeft: 4,
  },

  // Marca de mensagem enviada FORA do sistema (viaApp === false): a pessoa
  // respondeu direto pelo celular/outro aparelho e o Baileys só sincronizou.
  viaAppIcon: {
    fontSize: 16,
    verticalAlign: "middle",
    marginLeft: 4,
    color: "#E6B800",
    opacity: 0.85,
  },
  // Segue o tom do horário (não o amarelo do viaApp): é rastro, não alerta.
  respostaRapidaIcon: {
    fontSize: 16,
    verticalAlign: "middle",
    marginLeft: 4,
    color: "var(--text-muted)",
    opacity: 0.85,
  },

  deletedIcon: {
    fontSize: 18,
    verticalAlign: "middle",
    marginRight: 4,
  },

  ackDoneAllIcon: {
    color: green[500],
    fontSize: 18,
    verticalAlign: "middle",
    marginLeft: 4,
  },

  downloadMedia: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "inherit",
    padding: 10,
  },

  // Nome do arquivo acima do botão de download (#15203). `wordBreak` porque nome de
  // documento passa fácil dos 60 caracteres e estouraria a largura do balão.
  nomeArquivoAnexo: {
    maxWidth: 260,
    marginBottom: 6,
    fontSize: 13,
    fontWeight: 500,
    textAlign: "center",
    wordBreak: "break-word",
  },
  box: {
    position: "relative",
    marginLeft: "2px",
    marginRight: "2px",
    marginTop: "5px",
    [theme.breakpoints.down("sm")]: {
      display: "none"
    },
  },
  messageInfoIcode: {
    marginTop: 2,
    width: '100%',
    minWidth: '100%',
    maxWidth: '100%',
    height: "auto",
    display: "block",
    position: "relative",
    "&:hover #messageActionsButton": {
      display: "flex",
      position: "absolute",
      top: 0,
      right: 0,
    },

    fontWeight: "bold",
    whiteSpace: "pre-wrap",
    backgroundColor: "#FF8C00",
    color: "#303030",
    alignSelf: "flex-start",
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    paddingLeft: 5,
    paddingRight: 5,
    paddingTop: 5,
    paddingBottom: 0,
    boxShadow: "0 1px 1px #b3b3b3",
  },
  timestampInfoIcode: {
    fontSize: 11,
    position: "absolute",
    top: "50%",
    right: 5,
    transform: "translateY(-50%)",
    color: "#4F4F4F",
  },
  messageInternalNote: {
    alignSelf: "center",
    width: "92%",
    maxWidth: "92%",
    marginTop: 6,
    marginBottom: 6,
    padding: "8px 12px",
    backgroundColor: "#FFF8E1",
    border: "1px solid #F2D98D",
    borderLeft: "4px solid #E6B800",
    borderRadius: 8,
    color: "#5a4a00",
    boxShadow: "0 1px 1px #b3b3b3",
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
  },
  internalNoteHeader: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    marginBottom: 4,
  },
  internalNoteBadge: {
    fontSize: 10,
    fontWeight: "bold",
    textTransform: "uppercase",
    backgroundColor: "#E6B800",
    color: "#fff",
    borderRadius: 4,
    padding: "1px 6px",
    letterSpacing: 0.5,
  },
  internalNoteUser: {
    fontSize: 12,
    fontWeight: "bold",
    color: "#7a6500",
  },
  internalNoteTimestamp: {
    fontSize: 11,
    color: "#9a8a4a",
    marginLeft: "auto",
  },
  internalNoteBody: {
    fontSize: 14,
  },
  internalNoteAttachments: {
    marginTop: 8,
    display: "flex",
    flexDirection: "column",
    gap: 4,
  },
  internalNoteAttachment: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    fontSize: 13,
    color: "#5a4a00",
    textDecoration: "none",
    backgroundColor: "rgba(230, 184, 0, 0.12)",
    borderRadius: 6,
    padding: "4px 8px",
    "&:hover": {
      backgroundColor: "rgba(230, 184, 0, 0.22)",
    },
  },
  internalNoteAttachmentName: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    flex: 1,
  },
  internalNoteAttachmentSize: {
    fontSize: 11,
    color: "#9a8a4a",
  },
}));

const formatBytesInternalNote = (bytes) => {
  if (!bytes) return "";
  const k = 1024;
  const sizes = ["B", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(1))} ${sizes[i]}`;
};

// Âncora vazia antes de cada linha: é por ela que a busca acha a mensagem na tela.
const ancoraMensagem = (id) => `msg-${id}`;

const reducer = (state, action) => {
  if (action.type === "LOAD_MESSAGES") {
    const messages = action.payload;
    const newMessages = [];

    messages.forEach((message) => {
      const messageIndex = state.findIndex((m) => m.id === message.id);
      if (messageIndex !== -1) {
        state[messageIndex] = message;
      } else {
        newMessages.push(message);
      }
    });

    return [...newMessages, ...state];
  }

  // Resync depois de reconexão. LOAD_MESSAGES não serve aqui porque ele faz
  // prepend (é a paginação pra cima): o que chegou durante a queda é
  // necessariamente o mais novo, então entra no fim da conversa.
  if (action.type === "RESYNC_MESSAGES") {
    const messages = action.payload;
    const novas = [];

    messages.forEach((message) => {
      const messageIndex = state.findIndex((m) => m.id === message.id);
      if (messageIndex !== -1) {
        state[messageIndex] = message;
      } else {
        novas.push(message);
      }
    });

    return [...state, ...novas];
  }

  if (action.type === "ADD_MESSAGE") {
    const newMessage = action.payload;
    const messageIndex = state.findIndex((m) => m.id === newMessage.id);

    if (messageIndex !== -1) {
      state[messageIndex] = newMessage;
    } else {
      state.push(newMessage);
    }

    return [...state];
  }

  if (action.type === "UPDATE_MESSAGE") {
    const messageToUpdate = action.payload;
    const messageIndex = state.findIndex((m) => m.id === messageToUpdate.id);

    if (messageIndex !== -1) {
      state[messageIndex] = messageToUpdate;
    }

    return [...state];
  }

  if (action.type === "RESET") {
    return [];
  }
};

// Mídia sem legenda: o backend grava o nome do arquivo salvo em Message.body
// (`body: caption ? caption : filename` no verifyMediaMessage), então o balão
// mostrava "1782248202493.jpeg" como se fosse legenda — inclusive em mensagem
// que chegou do cliente e em mensagem enviada por outro aparelho. Aqui: se o
// body é só o nome do arquivo, documento mostra o nome original e os outros
// tipos não mostram legenda nenhuma (igual WhatsApp Web).
const corpoMensagem = (message) => {
  /// o body do contato é o vCard cru — quem o mostra é o card ///
  if (message?.mediaType === "vcard") return "";
  const corpo = message?.body || "";
  if (!message?.mediaUrl || !corpo) return corpo;
  if (corpo.trim() !== nomeArquivoSalvo(message)) return corpo;
  return nomeOriginalDocumento(message) || "";
};

// Reação chega em Messages.reactions (JSON) e não como mensagem própria — o balão
// reagido é que mostra o emoji. JSON quebrado não pode derrubar a conversa.
const lerReacoes = (message) => {
  if (!message?.reactions) return [];
  try {
    const lista =
      typeof message.reactions === "string"
        ? JSON.parse(message.reactions)
        : message.reactions;
    return Array.isArray(lista) ? lista.filter((r) => r && r.emoji) : [];
  } catch (err) {
    return [];
  }
};

// As 6 que o WhatsApp oferece na barrinha rápida.
const REACOES_RAPIDAS = ["👍", "❤️", "😂", "😮", "😢", "🙏"];

/// linhas locais nossas: nunca foram para o WhatsApp ///
const TIPOS_LOCAIS = ["internal_note", "info_icode"];

const ROTULOS_MIDIA = {
  image: "Foto",
  video: "Vídeo",
  audio: "Áudio",
  application: "Documento",
  text: "Documento",
};

// Rótulo pra prévia de citação: no balão a mídia aparece, mas na citação sem
// legenda sobraria um espaço vazio.
const rotuloMidia = (message) => {
  if (message?.mediaType === "vcard") return resumoDoVCard(message.body);
  if (!message?.mediaUrl) return "";
  const arquivo = (nomeArquivoSalvo(message) || "").toLowerCase();
  if (arquivo.endsWith(".webp")) return "Figurinha";
  return ROTULOS_MIDIA[message.mediaType] || "Anexo";
};

// Onde o cliente clicou. Só o Baileys manda a rede (sourceApp); no oficial ela não vem, e
// quem identifica é a URL de origem — instagram.com/p/..., fb.me/... ou wa.me/wamo/status.
const rotuloAnuncio = (anuncio) => {
  const fonte = (anuncio.fonte || "").toLowerCase();
  const url = (anuncio.url || "").toLowerCase();
  if (fonte.includes("instagram") || url.includes("instagram.com")) return "Anúncio no Instagram";
  if (url.includes("wamo/status")) return "Anúncio no Status";
  if (fonte.includes("facebook") || url.includes("fb.me") || url.includes("facebook.com")) {
    return "Anúncio no Facebook";
  }
  return anuncio.tipo === "post" ? "Publicação" : "Anúncio";
};

const textoLink = (url) => {
  const limpo = String(url).replace(/^https?:\/\//, "").replace(/\/$/, "");
  return limpo.length > 42 ? `${limpo.slice(0, 41)}…` : limpo;
};

// O backend só grava `anuncio` quando há o que mostrar, mas mensagem antiga tem a coluna
// como texto cru (o getter do model é que devolve objeto).
const lerAnuncio = (message) => {
  const bruto = message?.anuncio;
  if (!bruto) return null;
  if (typeof bruto === "object") return bruto;
  try {
    return JSON.parse(bruto);
  } catch (e) {
    return null;
  }
};

const MessagesList = ({ ticketId, isGroup, urlBackend, conOficial, whatsappId, canal, irParaMensagem }) => {
  const classes = useStyles({ canal });
  //const [inputs, setInputs] = useState({});

  const [messagesList, dispatch] = useReducer(reducer, []);
  const [pageNumber, setPageNumber] = useState(1);
  const [resyncKey, setResyncKey] = useState(0);
  const [hasMore, setHasMore] = useState(false);
  const [loading, setLoading] = useState(false);
  const lastMessageRef = useRef();

  const [selectedMessage, setSelectedMessage] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const messageOptionsMenuOpen = Boolean(anchorEl);
  // Seletor de reação: âncora (o botão do balão), qual mensagem, e se já abriu o
  // emoji-mart completo em vez da barrinha das 6.
  const [reactAnchor, setReactAnchor] = useState(null);
  const [reactMessage, setReactMessage] = useState(null);
  const [reactPickerAberto, setReactPickerAberto] = useState(false);
  const reactPopoverRef = useRef(null);
  const currentTicketId = useRef(ticketId);
  const { user } = useContext(AuthContext);
  // Backend da conexão do ticket quando não é um dos do usuário (conversa aberta pelo acesso por
  // filial); com o vínculo fica null, e trocar de conversa não reabre os sockets.
  const semBarraFinal = u => (u || "").trim().replace(/\/+$/, "");
  const urlBackendForaDoUsuario =
    urlBackend && semBarraFinal(urlBackend) !== semBarraFinal(process.env.REACT_APP_BACKEND_URL)
      && !(user?.whatsapps || []).some(w => semBarraFinal(w.urlBackend) === semBarraFinal(urlBackend))
      ? urlBackend : null;

  /*const [contact, setContact] = useState({});

  async function fetch() {
    try {
      const { data } = await api.get("/tickets/" + ticketId);
      setContact(data.contact);
    } catch (err) {
    }
  }

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs(values => ({ ...values, [name]: value }))
  }

  async function ZDGGetWppId() {
    await fetch();
    const req = http.request(init2, callback2);
    const body = '{"ticketid":' + ticketId + '}';
    await req.write(body);
    req.end();
  }

  async function ZDGSyncUser() {
    const req = http.request(init, callback);
    const number = `${contact.number}`;
    const body = '{"user":"' + number + '","limit":' + inputs.limite + ',"ticketwhatsappId":' + inputs.id + '}';
    alert(`Importando o histório de: ${contact.name} - WPP: ${contact.number} - Total de: ` + inputs.limite + ` mensagens.`);
    await req.write(body);
    req.end();
  }

  const ZDGEmailAttach = async () => {
    alert('Carregando mensagens...')
    const zdgSubject = 'Ticket Fechado no Whaticket';
    const zdgText = 'Conversa exportada do Whaticket';
    const zdgFileName = 'ZDG.txt';
    const req = http.request(init3, callback);
    const promises = messagesList.map(async (message) => {
      const body = message.body;
      const ticketId = message.ticketId;
      const fromMe = message.fromMe;
      const created = message.createdAt;
      return 'Ticket : ' + ticketId + '\nMensagem: ' + body + '\nFrom me: ' + fromMe + '\nCriado em: ' + created + '\n\n ----- \n\n'
    })
    const allMessages = await Promise.all(promises)
    alert(allMessages)
    const body = `{"zdgSubject":"` + zdgSubject + `","zdgText":"` + zdgText.replace(/\n/g, "\\n") + `","zdgFileName":"` + zdgFileName + `","zdgContent":"` + allMessages.toString().replace(/\n/g, "\\n").replace(/,/g, "") + `"}`;
    req.write(body);
    req.end();
    alert('E-mail enviado... caso não tenha recebido, verifique o log do seu backend.')
  }*/

  useEffect(() => {
    dispatch({ type: "RESET" });
    setPageNumber(1);

    currentTicketId.current = ticketId;
  }, [ticketId]);

  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchMessages = async () => {
        try {
          const { data } = await api.get("/messages/" + ticketId + "/" + (localStorage.getItem("icode_options") && localStorage.getItem("icode_options").includes("read")), {
            // A página sai do que a lista já tem (e não só do contador): depois de a busca levar a
            // tela a uma mensagem velha, a lista passa de 150 de uma vez, e o contador sozinho
            // buscaria um trecho mais atrás, deixando buraco. Deslocamento <= tamanho nunca deixa.
            params: { pageNumber: pageNumber === 1 ? 1 : Math.floor(messagesListRef.current.length / 150) + 1 },
          });

          if (currentTicketId.current === ticketId) {
            dispatch({ type: "LOAD_MESSAGES", payload: data.messages });
            setHasMore(data.hasMore);
            setLoading(false);
          }

          if (pageNumber === 1 && data.messages.length > 1) {
            scrollToBottom();
          }
        } catch (err) {
          setLoading(false);
          // 404 aqui é conversa inexistente ou de conexão sem acesso — o mesmo que o
          // GET /tickets/:id devolve, e o Ticket já troca a tela inteira pelo painel
          // "Conversa não encontrada". O toast só repetiria pelo código cru
          // ("Nenhum tíquete encontrado com este ID"), por cima da explicação.
          // Mesma regra das telas de acesso negado (ver errors/toastError.js).
          if (err?.response?.status !== 404) toastError(err);
        }
      };
      fetchMessages();
    }, 500);
    return () => {
      clearTimeout(delayDebounceFn);
    };
  }, [pageNumber, ticketId]);

  // Reconexão de socket: rebusca a 1ª página (as 150 mais recentes) e mescla, sem
  // RESET, pra não piscar a conversa nem perder o histórico já rolado. Não entra
  // no efeito de cima porque lá o dispatch é LOAD_MESSAGES, que faz prepend.
  useEffect(() => {
    if (!resyncKey) return;

    const ticketDoResync = ticketId;
    const ultimaNaTela = messagesList[messagesList.length - 1]?.id;
    let cancelado = false;

    const resincronizar = async () => {
      try {
        const { data } = await api.get("/messages/" + ticketDoResync + "/" + (localStorage.getItem("icode_options") && localStorage.getItem("icode_options").includes("read")), {
          params: { pageNumber: 1 },
        });

        if (cancelado || currentTicketId.current !== ticketDoResync) return;

        dispatch({ type: "RESYNC_MESSAGES", payload: data.messages });

        // Só desce se o resync trouxe mensagem nova: reconexão em conversa parada
        // não pode arrancar do histórico quem estava lendo pra cima.
        const ultimaBuscada = data.messages[data.messages.length - 1]?.id;
        if (ultimaBuscada && ultimaBuscada !== ultimaNaTela) {
          scrollToBottom();
        }
      } catch (err) {
        toastError(err);
      }
    };

    resincronizar();
    return () => {
      cancelado = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resyncKey]);

  useEffect(() => {
    let urlsUnicas = [];
    if (user && JSON.stringify(user) !== '{}') {
      const normalizeUrl = u => (u || "").trim().replace(/\/+$/, "");
      urlsUnicas = new Set([normalizeUrl(process.env.REACT_APP_BACKEND_URL)]);
      [...(user.whatsapps || []).map(w => w.urlBackend), urlBackendForaDoUsuario]
        .map(normalizeUrl)
        .filter(Boolean)
        .forEach(url => urlsUnicas.add(url));
      urlsUnicas = [...urlsUnicas];
    } else {
      console.error("USUARIO NÃO ENCONTRADO NO SOCKET");
    }
    const sockets = [];
    urlsUnicas.forEach(url => {
      const socket = openSocket(url.trim() + "/");
      sockets.push(socket);

      socket.on("connect", () => socket.emit("joinChatBox", ticketId));

      aoReconectar(socket, () => setResyncKey(chave => chave + 1));

      socket.on("appMessage", (data) => {
        if (data.action === "create") {
          dispatch({ type: "ADD_MESSAGE", payload: data.message });
          scrollToBottom();
        }

        if (data.action === "update") {
          dispatch({ type: "UPDATE_MESSAGE", payload: data.message });
        }
      });
    });
    return () => {
      sockets.forEach(socket => socket.disconnect());
    };
  }, [ticketId, urlBackendForaDoUsuario]);

  // --- Busca na conversa: levar a tela até uma mensagem, mesmo mais velha que as já carregadas ---
  const messagesListRef = useRef(messagesList);
  messagesListRef.current = messagesList;
  const alvoBusca = useRef(null);
  // Enquanto a tela é levada até o resultado o scroll se mexe sozinho (a lista cresce por cima);
  // sem esta folga isso contava como "chegou no topo" e carregava mais uma página por cima.
  const semPaginarAte = useRef(0);
  const cargaBusca = useRef(0);
  const buscaCarregando = useRef(false);

  const rolarParaAlvo = () => {
    const ancora = alvoBusca.current && document.getElementById(ancoraMensagem(alvoBusca.current));
    if (!ancora) return false;
    alvoBusca.current = null;
    semPaginarAte.current = Date.now() + 1500;
    const linha = ancora.nextElementSibling;
    ancora.scrollIntoView({ block: "center" });
    // O layout ainda se acomoda logo depois de a lista crescer (a medição muda e a mensagem escorrega
    // pra cima), então centraliza de novo uma vez.
    setTimeout(() => ancora.scrollIntoView({ block: "center" }), 300);
    if (linha) {
      linha.classList.remove(classes.destaqueBusca);
      void linha.offsetWidth; // reinicia a animação se clicar no mesmo resultado de novo
      linha.classList.add(classes.destaqueBusca);
      setTimeout(() => linha.classList.remove(classes.destaqueBusca), 2600);
    }
    return true;
  };

  useEffect(() => {
    if (!irParaMensagem) {
      // Troca de conversa: a carga em voo deixa de valer (e o loading é da conversa nova).
      cargaBusca.current++;
      buscaCarregando.current = false;
      alvoBusca.current = null;
      return undefined;
    }
    const id = irParaMensagem.id;
    const ticketDaBusca = ticketId;
    // Cada clique é uma carga; só a mais recente mexe no loading e no alvo.
    const minhaCarga = ++cargaBusca.current;
    alvoBusca.current = id;
    if (rolarParaAlvo()) {
      if (buscaCarregando.current) {
        buscaCarregando.current = false;
        setLoading(false);
      }
      return undefined;
    }

    const maisRecente = () => minhaCarga === cargaBusca.current && currentTicketId.current === ticketDaBusca;
    const carregarAteAlvo = async () => {
      buscaCarregando.current = true;
      setLoading(true);
      try {
        const atuais = new Set(messagesListRef.current.map((m) => m.id));
        const acumuladas = [];
        let antes = messagesListRef.current[0]?.dataMensagem;
        let ultimo = null;
        // Cada chamada traz até 500 mensagens; 40 voltas = 20 mil mensagens, teto contra laço infinito.
        for (let volta = 0; volta < 40; volta++) {
          const { data } = await api.get(`/messages/${ticketDaBusca}/ate/${encodeURIComponent(id)}`, { params: { antes } });
          if (!maisRecente()) return;
          const antesDaVolta = acumuladas.length;
          data.messages.forEach((m) => {
            if (!atuais.has(m.id)) {
              atuais.add(m.id);
              acumuladas.push(m);
            }
          });
          ultimo = data;
          // Sem mensagem nova (mais de 500 com o mesmo horário) `antes` não anda: seguir só repete o lote.
          if (data.completo || !data.maisAntiga || acumuladas.length === antesDaVolta) break;
          antes = data.maisAntiga;
        }
        if (!atuais.has(id)) {
          alvoBusca.current = null;
          toast.warn("Não foi possível levar a conversa até essa mensagem.");
          return;
        }
        acumuladas.sort((a, b) => (a.dataMensagem < b.dataMensagem ? -1 : a.dataMensagem > b.dataMensagem ? 1 : 0));
        semPaginarAte.current = Date.now() + 1500;
        dispatch({ type: "LOAD_MESSAGES", payload: acumuladas });
        if (ultimo) setHasMore(ultimo.hasMore);
      } catch (err) {
        if (maisRecente()) alvoBusca.current = null;
        toastError(err);
      } finally {
        if (minhaCarga === cargaBusca.current) {
          buscaCarregando.current = false;
          setLoading(false);
        }
      }
    };
    carregarAteAlvo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [irParaMensagem]);

  // Quando a lista renderiza com a mensagem que faltava, rola até ela.
  useEffect(() => {
    if (alvoBusca.current) rolarParaAlvo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messagesList]);

  const loadMore = () => {
    setPageNumber((prevPageNumber) => prevPageNumber + 1);
  };

  const scrollToBottom = () => {
    if (lastMessageRef.current) {
      lastMessageRef.current.scrollIntoView({});
    }
  };

  const handleScroll = (e) => {
    if (!hasMore) return;
    const { scrollTop } = e.currentTarget;

    if (scrollTop === 0) {
      document.getElementById("messagesList").scrollTop = 1;
    }

    if (loading || Date.now() < semPaginarAte.current) {
      return;
    }

    if (scrollTop < 50) {
      loadMore();
    }
  };

  // Baixa como blob para salvar com o nome original (#15017): o `download` do <a> não
  // vale para outra origem, e pelo href o arquivo saía com o nome do servidor.
  const handleDownloadMedia = async (message) => {
    try {
      const resposta = await fetch(message.mediaUrl);
      if (!resposta.ok) throw new Error(`HTTP ${resposta.status}`);
      const url = window.URL.createObjectURL(await resposta.blob());
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", nomeDownloadMidia(message));
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      window.open(message.mediaUrl, "_blank", "noopener");
    }
  };

  const handleOpenMessageOptionsMenu = (e, message) => {
    setAnchorEl(e.currentTarget);
    setSelectedMessage(message);
  };

  // Download de anexo interno: a rota é autenticada (isAuth), então buscamos o
  // blob via axios (que injeta o token) e disparamos o download no navegador.
  const handleDownloadInternalAttachment = async (att) => {
    try {
      const { data } = await api.get(`/internal-notes/attachment/${att.id}`, {
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(
        new Blob([data], { type: att.mimeType || "application/octet-stream" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        att.originalName || att.fileName || `anexo-${att.id}`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      toastError(err);
    }
  };

  const handleCloseMessageOptionsMenu = (e) => {
    setAnchorEl(null);
  };

  const handleAbrirReacoes = (e, message) => {
    setReactAnchor(e.currentTarget);
    setReactMessage(message);
    setReactPickerAberto(false);
  };

  const handleFecharReacoes = () => {
    setReactAnchor(null);
    setReactMessage(null);
    setReactPickerAberto(false);
  };

  // A barrinha tem ~250px e o emoji-mart ~350x420: o Popover mediu o conteúdo pequeno,
  // então precisa recalcular depois da troca, senão o seletor grande abre estourando a
  // tela em vez de se encaixar perto do balão.
  const handleAbrirPicker = () => {
    setReactPickerAberto(true);
    setTimeout(() => reactPopoverRef.current?.updatePosition(), 0);
  };

  // Reagir é o mesmo que reagir pelo celular: o backend manda pro WhatsApp e o
  // balãozinho vem de volta pelo socket. Clicar no emoji que já é o seu REMOVE a
  // reação (emoji vazio), igual WhatsApp.
  const handleReagir = async (emoji) => {
    const message = reactMessage;
    handleFecharReacoes();
    if (!message) return;

    const minha = lerReacoes(message).find((r) => r.fromMe);
    const escolhido = minha && minha.emoji === emoji ? "" : emoji;
    try {
      const apiReacao = urlBackend ? createApi(urlBackend) : api;
      await apiReacao.post(`/messages/${message.id}/reaction`, { emoji: escolhido });
    } catch (err) {
      toastError(err);
    }
  };

  const checkMessageMedia = (message) => {
    if (message.mediaType === "location" && message.body.split('|').length >= 2) {
      let locationParts = message.body.split('|')
      let imageLocation = locationParts[0]
      let linkLocation = locationParts[1]

      let descriptionLocation = null

      if (locationParts.length > 2)
        descriptionLocation = message.body.split('|')[2]

      return <LocationPreview image={imageLocation} link={linkLocation} description={descriptionLocation} />
    }
    else if (message.mediaType === "vcard") {
      const contatos = lerVCards(message.body);
      if (!contatos.length) return null;
      /// a partir de 3 vira resumo com "Ver todos", como no WhatsApp ///
      if (contatos.length >= 3) {
        return <VcardGrupoPreview contatos={contatos} whatsappId={whatsappId} />;
      }
      return (
        <>
          {contatos.map((contato, indice) => (
            <React.Fragment key={indice}>
              {indice > 0 && <Divider />}
              <VcardPreview contato={contato} whatsappId={whatsappId} />
            </React.Fragment>
          ))}
        </>
      );
    }
    else if (message.mediaType === "image") {
      return <ModalImageCors imageUrl={message.mediaUrl} />;
    } else if (message.mediaType === "audio") {
      return <AudioMessage src={message.mediaUrl} type="audio/ogg" />;
    } else if (message.mediaType === "video") {
      return (
        <video
          className={classes.messageMedia}
          src={message.mediaUrl}
          controls
        />
      );
    } else {
      /// anexo: o balão mostrava só [DOWNLOAD] e ninguém sabia o que era (#15203) ///
      const nomeArquivo = nomeArquivoNoCard(message);
      return (
        <>
          <div className={classes.downloadMedia}>
            {nomeArquivo && (
              <span className={classes.nomeArquivoAnexo} title={nomeArquivo}>
                {nomeArquivo}
              </span>
            )}
            <Button
              startIcon={<GetApp />}
              color="primary"
              variant="outlined"
              onClick={() => handleDownloadMedia(message)}
            >
              Download
            </Button>
          </div>
          <Divider />
        </>
      );
    }
  };

  const renderMessageAck = (message) => {
    if (message.ack === -1) {
      return <Cancel fontSize="small" className={classes.ackIcons} />;
    }
    if (message.ack === 0) {
      return <AccessTime fontSize="small" className={classes.ackIcons} />;
    }
    if (message.ack === 1) {
      return <Done fontSize="small" className={classes.ackIcons} />;
    }
    if (message.ack === 2) {
      return <DoneAll fontSize="small" className={classes.ackIcons} />;
    }
    if (message.ack === 3 || message.ack === 4) {
      return <DoneAll fontSize="small" className={classes.ackDoneAllIcon} />;
    }
  };

  const renderDailyTimestamps = (message, index) => {
    if (index === 0) {
      return (
        <span
          className={classes.dailyTimestamp}
          key={`timestamp-${message.id}`}
        >
          <div className={classes.dailyTimestampText}>
            {format(parseISO(messagesList[index].dataMensagem), "dd/MM/yyyy")}
          </div>
        </span>
      );
    }
    if (index <= messagesList.length - 1) {
      let messageDay = parseISO(messagesList[index].dataMensagem);
      let previousMessageDay = parseISO(messagesList[index - 1].dataMensagem);

      if (!isSameDay(messageDay, previousMessageDay)) {
        return (
          <span
            className={classes.dailyTimestamp}
            key={`timestamp-${message.id}`}
          >
            <div className={classes.dailyTimestampText}>
              {format(parseISO(messagesList[index].dataMensagem), "dd/MM/yyyy")}
            </div>
            <div
              key={`ref-${message.dataMensagem}`}
              ref={lastMessageRef}
              style={{ float: "left", clear: "both" }}
            />
          </span>
        );
      }
    }
    if (index === messagesList.length - 1) {
      return (
        <div
          key={`ref-${message.dataMensagem}`}
          ref={lastMessageRef}
          style={{ float: "left", clear: "both" }}
        />
      );
    }
  };

  const renderMessageDivider = (message, index) => {
    if (index < messagesList.length && index > 0) {
      let messageUser = messagesList[index].fromMe;
      let previousMessageUser = messagesList[index - 1].fromMe;
      let messageType = messagesList[index].mediaType;
      let previousMessageType = messagesList[index - 1].mediaType;
      const isSpecial = (t) => t === "info_icode" || t === "internal_note";

      if (isSpecial(messageType) && !isSpecial(previousMessageType)) {
        return (
          <span style={{ marginTop: 16 }} key={`divider-${message.id}`}></span>
        );
      }

      if (!isSpecial(messageType) && isSpecial(previousMessageType)) {
        return (
          <span style={{ marginTop: 16 }} key={`divider-${message.id}`}></span>
        );
      }

      if (messageUser !== previousMessageUser) {
        return (
          <span style={{ marginTop: 16 }} key={`divider-${message.id}`}></span>
        );
      }
    }
  };

  const renderQuotedMessage = (message) => {
    return (
      <div
        className={clsx(classes.quotedContainerLeft, {
          [classes.quotedContainerRight]: message.fromMe,
        })}
      >
        <span
          className={clsx(classes.quotedSideColorLeft, {
            [classes.quotedSideColorRight]: message.quotedMsg?.fromMe,
          })}
        ></span>
        <div className={classes.quotedMsg}>
          {!message.quotedMsg?.fromMe && (
            <span className={classes.messageContactName}>
              {message.quotedMsg?.contact?.name}
            </span>
          )}
          {corpoMensagem(message.quotedMsg) || rotuloMidia(message.quotedMsg)}
        </div>
      </div>
    );
  };

  // Anúncio de onde o cliente veio, como card no topo do balão (igual ao WhatsApp Web).
  // Clicar abre o anúncio; o texto inteiro, que costuma ser longo, fica no title.
  const renderAnuncio = (message) => {
    const anuncio = lerAnuncio(message);
    if (!anuncio) return null;

    // Só as duas: urlMidia é o LINK da mídia do anúncio (facebook.com/reel/...), não uma
    // imagem — usar de src dava ícone quebrado. Sem imagem, o card vai só com texto.
    const imagem = anuncio.urlMiniaturaLocal || anuncio.urlMiniatura;
    const destino = anuncio.url || anuncio.urlMidia;
    const rotulo = rotuloAnuncio(anuncio);
    const detalhe = [rotulo, anuncio.titulo, anuncio.corpo, destino]
      .filter(Boolean)
      .join("\n\n");

    return (
      <a
        className={classes.anuncioCard}
        href={destino || undefined}
        target="_blank"
        rel="noopener noreferrer"
        title={detalhe}
      >
        <span className={classes.anuncioBarra} />
        {imagem && (
          <span className={classes.anuncioMiniaturaBox}>
            <img src={imagem} alt={rotulo} className={classes.anuncioMiniatura} />
            {anuncio.midia === "video" && (
              <PlayCircleFilled className={classes.anuncioPlay} />
            )}
          </span>
        )}
        <span className={classes.anuncioTextos}>
          <span className={classes.anuncioFonte}>
            <LocalOffer className={classes.anuncioFonteIcone} />
            {rotulo}
          </span>
          {anuncio.titulo && (
            <span className={classes.anuncioTitulo}>{anuncio.titulo}</span>
          )}
          {anuncio.corpo && (
            <span className={classes.anuncioCorpo}>{anuncio.corpo}</span>
          )}
          {destino && (
            <span className={classes.anuncioLink}>
              <OpenInNew className={classes.anuncioLinkIcone} />
              {textoLink(destino)}
            </span>
          )}
        </span>
      </a>
    );
  };

  // Botão de reagir do balão (aparece no hover). Mensagem interna do sistema nunca foi
  // para o WhatsApp, então não tem o que reagir.
  const renderBotaoReagir = (message) => {
    if (message.isDeleted || TIPOS_LOCAIS.includes(message.mediaType)) return null;

    return (
      <IconButton
        size="small"
        id="messageReactButton"
        title="Reagir"
        className={clsx(classes.reactButton, {
          [classes.reactButtonVisivel]: reactMessage?.id === message.id,
        })}
        onClick={(e) => handleAbrirReacoes(e, message)}
      >
        <Mood className={classes.reactIcon} />
      </IconButton>
    );
  };

  // Emojis distintos + total, como no WhatsApp Web (três reagiram com 👍 = um 👍 e "3").
  // Quem reagiu vai no title: no grupo é a única forma de saber.
  const renderReactions = (reacoes, message) => {
    const emojis = [...new Set(reacoes.map((r) => r.emoji))].slice(0, 3);
    const quem = reacoes
      .map((r) => `${r.emoji}  ${r.fromMe ? "Você" : r.nome || r.autor || "Cliente"}`)
      .join("\n");

    return (
      <Tooltip
        title={<span style={{ whiteSpace: "pre-line" }}>{quem}</span>}
        placement={message.fromMe ? "left" : "right"}
      >
        <span className={classes.reactionsBubble}>
          {emojis.join(" ")}
          {reacoes.length > 1 && (
            <span className={classes.reactionsCount}>{reacoes.length}</span>
          )}
        </span>
      </Tooltip>
    );
  };

  // Marca "Encaminhada" (RN02 do #14436). Fica ACIMA da mídia e do corpo, como no
  // WhatsApp — por isso é irmã do checkMessageMedia, e não filha do textContentItem.
  //
  // Mensagem NOSSA encaminhada não entra aqui: sai de propósito sem contextInfo, para
  // chegar como mensagem normal (RN01).
  const renderEncaminhada = (message) => {
    if (!ehEncaminhada(message)) return null;

    return (
      <div className={classes.encaminhada}>
        <Reply className={classes.encaminhadaIcone} />
        {i18n.t("messagesList.encaminhada")}
      </div>
    );
  };

  // O contato apagou para todos no WhatsApp a mensagem que ele enviou (#15256). O corpo
  // continua visível de propósito — a Roma quer o histórico completo —, então a tarja é a
  // única coisa que distingue uma mensagem que vale de uma que o cliente desfez.
  //
  // Só mensagem recebida: `isDeleted` (nós apagamos) é outro caso e tem render próprio no
  // ramo fromMe. Em grupo o texto é "Mensagem apagada", sem "pelo cliente".
  const renderApagadaPeloCliente = (message) => {
    if (!message.apagadaPeloCliente) return null;

    return (
      <div className={classes.apagada}>
        <Block className={classes.apagadaIcone} />
        {i18n.t(isGroup ? "messagesList.apagada" : "messagesList.apagadaPeloCliente")}
      </div>
    );
  };

  const renderMessages = () => {
    if (messagesList.length > 0) {
      const viewMessagesList = messagesList.map((message, index) => {
        // Documento sem legenda tem o nome do arquivo no lugar dela (ver corpoMensagem),
        // e esse nome agora sai no card de download: repetido embaixo seria o mesmo texto
        // duas vezes no mesmo balão. Quando o card mostra o nome, aqui fica só a legenda
        // de verdade — "" quando não existe. `corpoMensagem` segue intacto porque é ele
        // que alimenta a prévia da citação, onde não há card para mostrar o nome.
        const corpo = nomeArquivoNoCard(message)
          ? legendaAbaixoDoCard(message)
          : corpoMensagem(message);
        const reacoes = lerReacoes(message);
        if (message.mediaType === 'info_icode') {
          return (
            <React.Fragment key={message.id}>
              {renderDailyTimestamps(message, index)}
              {renderMessageDivider(message, index)}
              <span id={ancoraMensagem(message.id)} />
              <div className={classes.messageInfoIcode}>
                <div className={classes.textContentItem}>
                  <span className="msg-body"><MarkdownWrapper>{message.body}</MarkdownWrapper></span>
                  <span className={classes.timestampInfoIcode}>
                    {format(parseISO(message.dataMensagem), "dd/MM/yyyy HH:mm")}
                  </span>
                </div>
              </div>
            </React.Fragment>
          );
        } else if (message.mediaType === 'internal_note') {
          let meta = {};
          try {
            meta = message.json ? JSON.parse(message.json) : {};
          } catch (e) {
            meta = {};
          }
          const attachments = Array.isArray(meta.attachments) ? meta.attachments : [];
          let dataFmt = "";
          try {
            dataFmt = format(parseISO(message.dataMensagem), "dd/MM/yyyy HH:mm");
          } catch (e) {
            dataFmt = "";
          }
          return (
            <React.Fragment key={message.id}>
              {renderDailyTimestamps(message, index)}
              {renderMessageDivider(message, index)}
              <span id={ancoraMensagem(message.id)} />
              <div className={classes.messageInternalNote}>
                <div className={classes.internalNoteHeader}>
                  <span className={classes.internalNoteBadge}>Interno</span>
                  {meta.userName && (
                    <span className={classes.internalNoteUser}>{meta.userName}</span>
                  )}
                  {dataFmt && (
                    <span className={classes.internalNoteTimestamp}>{dataFmt}</span>
                  )}
                </div>
                <div className={classes.internalNoteBody}>
                  <MarkdownWrapper>{message.body}</MarkdownWrapper>
                </div>
                {attachments.length > 0 && (
                  <div className={classes.internalNoteAttachments}>
                    {attachments.map((att) => (
                      <div
                        key={att.id || att.url}
                        className={classes.internalNoteAttachment}
                        style={{ cursor: "pointer" }}
                        onClick={() => handleDownloadInternalAttachment(att)}
                      >
                        <GetApp fontSize="small" />
                        <span className={classes.internalNoteAttachmentName}>
                          {att.originalName || att.fileName}
                        </span>
                        {att.size ? (
                          <span className={classes.internalNoteAttachmentSize}>
                            {formatBytesInternalNote(att.size)}
                          </span>
                        ) : null}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </React.Fragment>
          );
        } else if (!message.fromMe) {
          return (
            <React.Fragment key={message.id}>
              {renderDailyTimestamps(message, index)}
              {renderMessageDivider(message, index)}
              <span id={ancoraMensagem(message.id)} />
              <div className={classes.linhaMensagem}>
              <div
                className={clsx(classes.messageLeft, {
                  [classes.messageWithReactions]: reacoes.length > 0,
                })}
              >
                <IconButton
                  variant="contained"
                  size="small"
                  id="messageActionsButton"
                  /*disabled={message.isDeleted || !(localStorage.getItem("icode_options") && localStorage.getItem("icode_options").includes("input"))}*/
                  disabled={message.isDeleted}
                  className={classes.messageActionsButton}
                  onClick={(e) => handleOpenMessageOptionsMenu(e, message)}
                >
                  <ExpandMore />
                </IconButton>
                {isGroup && (
                  <span className={classes.messageContactName}>
                    {message.contact?.name}
                  </span>
                )}
                {renderApagadaPeloCliente(message)}
                {renderEncaminhada(message)}
                {(message.mediaUrl || message.mediaType === "vcard"
                  //|| message.mediaType === "multi_vcard" 
                ) && checkMessageMedia(message)}
                <div
                  className={clsx(classes.textContentItem, {
                    [classes.textContentItemSemLegenda]: !corpo,
                  })}
                >
                  {renderAnuncio(message)}
                  {message.quotedMsg && renderQuotedMessage(message)}
                  {corpo && (
                    <span className="msg-body"><MarkdownWrapper>{corpo}</MarkdownWrapper></span>
                  )}
                  <span className={classes.timestamp}>
                    {message.isUpdated && "Editada "}
                    {format(parseISO(message.dataMensagem), "HH:mm")}
                  </span>
                </div>
                {reacoes.length > 0 && renderReactions(reacoes, message)}
              </div>
              {renderBotaoReagir(message)}
              </div>
            </React.Fragment>
          );
        } else {
          return (
            <React.Fragment key={message.id}>
              {renderDailyTimestamps(message, index)}
              {renderMessageDivider(message, index)}
              <span id={ancoraMensagem(message.id)} />
              <div className={clsx(classes.linhaMensagem, classes.linhaMensagemMinha)}>
              <div
                className={clsx(classes.messageRight, {
                  [classes.messageWithReactions]: reacoes.length > 0,
                })}
              >
                <IconButton
                  variant="contained"
                  size="small"
                  id="messageActionsButton"
                  /*disabled={message.isDeleted || !(localStorage.getItem("icode_options") && localStorage.getItem("icode_options").includes("input"))}*/
                  disabled={message.isDeleted}
                  className={classes.messageActionsButton}
                  onClick={(e) => handleOpenMessageOptionsMenu(e, message)}
                >
                  <ExpandMore />
                </IconButton>
                {renderEncaminhada(message)}
                {(message.mediaUrl || message.mediaType === "vcard"
                  //|| message.mediaType === "multi_vcard" 
                ) && checkMessageMedia(message)}
                <div
                  className={clsx(classes.textContentItem, {
                    [classes.textContentItemDeleted]: message.isDeleted,
                    [classes.textContentItemSemLegenda]: !corpo,
                  })}
                >
                  {message.isDeleted && (
                    <Block
                      color="disabled"
                      fontSize="small"
                      className={classes.deletedIcon}
                    />
                  )}
                  {message.quotedMsg && renderQuotedMessage(message)}
                  {corpo && (
                    <span className="msg-body"><MarkdownWrapper>{corpo}</MarkdownWrapper></span>
                  )}
                  <span className={classes.timestamp} title={motivoFalhaEnvio(message.motivo)}>
                    {message.isUpdated && "Editada "}
                    {format(parseISO(message.dataMensagem), "HH:mm")}
                    {message.viaApp === false && (
                      <PhoneAndroid
                        titleAccess="Enviada por fora do sistema (outro aparelho)"
                        className={classes.viaAppIcon}
                      />
                    )}
                    {message.quickAnswerId && (
                      <FlashOn
                        titleAccess={`Resposta rápida ${message.quickAnswerId}`}
                        className={classes.respostaRapidaIcon}
                      />
                    )}
                    {renderMessageAck(message)}
                  </span>
                </div>
                {reacoes.length > 0 && renderReactions(reacoes, message)}
              </div>
              {renderBotaoReagir(message)}
              </div>
            </React.Fragment>
          );
        }
      });
      return viewMessagesList;
    } else {
      return <div>Say hello to your new contact!</div>;
    }
  };

  return (
    <div className={classes.messagesListWrapper}>
      {/* <Box className={classes.box}>
      <Grid container spacing={0} style={{ display:'flex', alignItems:'center', textAlign: 'center', paddingBottom:'10px'}}>
        <Grid item xs={12} md={2} sm={2}>
          <Button
          style={{fontSize:"10px"}}
          variant="contained"
          color="primary"
          onClick={() => {ZDGGetWppId();}}>
            ID WPP
          </Button>
        </Grid>
        <Grid item xs={12} md={2} sm={2}>
            <input 
              type="text" 
              name="id" 
              value={inputs.id || ""} 
              onChange={handleChange}
              required="required"
              placeholder="ID WPP"
              style={{width:"50%"}}
            />
        </Grid>
        <Grid item xs={12} md={2} sm={2}>
            <input 
              type="text" 
              name="limite" 
              value={inputs.limite || ""} 
              onChange={handleChange}
              required="required"
              placeholder="LIMITE"
              style={{width:"50%"}}
            />
        </Grid>
        <Grid item xs={12} md={3} sm={4}>
          <Button
          style={{fontSize:"10px", margin: "2px"}}
          variant="contained"
          color="primary"
          onClick={() => {ZDGSyncUser();}}>
            IMPORTAR CONVERSAS
          </Button>
        </Grid>
        <Grid item xs={12} md={3} sm={4}>
          <CSVLink style={{ textDecoration:'none'}} separator=";" filename={'zdg.csv'} data={messagesList.map((message) => ({ body: message.body, id: message.id, fromMe: message.fromMe, quoted : message.quotedMsg, isDel: message.isDeleted, mediaUrl : message.mediaUrl, type: message.mediaType, created : message.createdAt}))}>
            <Button
            style={{fontSize:"10px"}}
            variant="contained"
            color="primary">
              CSV
            </Button>
          </CSVLink>
          <Button
            onClick={() => {ZDGEmailAttach();}}
            style={{fontSize:"10px", margin: "2px"}}
            variant="contained"
            color="primary">
              EMAIL
          </Button>
        </Grid>
      </Grid>
      </Box> */}
      <MessageOptionsMenu
        message={selectedMessage}
        anchorEl={anchorEl}
        menuOpen={messageOptionsMenuOpen}
        urlBackend={urlBackend}
        handleClose={handleCloseMessageOptionsMenu}
        conOficial={conOficial}
        whatsappId={whatsappId}
      />
      <Popover
        action={reactPopoverRef}
        open={Boolean(reactAnchor)}
        anchorEl={reactAnchor}
        onClose={handleFecharReacoes}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        transformOrigin={{ vertical: "bottom", horizontal: "center" }}
        PaperProps={{ style: { borderRadius: reactPickerAberto ? 8 : 20, overflow: "visible" } }}
      >
        {reactPickerAberto ? (
          <Picker
            perLine={9}
            showPreview={false}
            showSkinTones={false}
            onSelect={(emoji) => handleReagir(emoji.native)}
          />
        ) : (
          <div className={classes.reactBarra}>
            {REACOES_RAPIDAS.map((emoji) => {
              const minha = lerReacoes(reactMessage || {}).find((r) => r.fromMe);
              return (
                <button
                  key={emoji}
                  type="button"
                  title={minha?.emoji === emoji ? "Remover reação" : emoji}
                  className={clsx(classes.reactBarraItem, {
                    [classes.reactBarraItemAtivo]: minha?.emoji === emoji,
                  })}
                  onClick={() => handleReagir(emoji)}
                >
                  {emoji}
                </button>
              );
            })}
            <IconButton
              size="small"
              title="Mais emojis"
              onClick={handleAbrirPicker}
            >
              <Add className={classes.reactBarraMais} />
            </IconButton>
          </div>
        )}
      </Popover>
      <div
        id="messagesList"
        className={classes.messagesList}
        onScroll={handleScroll}
      >
        {messagesList.length > 0 ? renderMessages() : []}
      </div>
      {loading && (
        <div>
          <CircularProgress className={classes.circleLoading} />
        </div>
      )}
    </div>
  );
};

export default MessagesList;